module.exports = __webpack_public_path__ + "media/images/apple-icon-57x57-7cf51efb.png";